import { type RootState } from '../store';

export const selectAvailableLanguages = (state: RootState) => state.i18n.availableLanguages;

export const selectLanguage = (state: RootState) => state.i18n.appLanguage?.language;
export const selectAppLanguage = (state: RootState) => state.i18n.appLanguage;

export const selectLocaleToString = (state: RootState) => {
  const { language, country } = state.i18n.appLanguage ?? { language: 'en', country: 'GB' };

  return `${language.toLocaleLowerCase()}-${country.toLocaleUpperCase()}`;
};
